import * as SX from './sx';
import * as Styled from './styles';

import { CurrentPlanTag } from '../current-plan-tag';
import { MostPopularTag } from '../most-popular-tag';
import { NextChargeTag } from '../next-charge-tag';
import { PlanTagline } from '../plan-tagline';
import type { PlanTagsProps as Props } from './types';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { usePlanCardContext } from '../../context';

export const PlanTags = memo(({ className }: Props) => {
  const { isMostPopular, currentPlan, selectedPlan } = usePlanCardContext();
  const { data } = useCurrentSubscriptionApi();

  const isCurrentPlan =
    !!currentPlan?.id && currentPlan.id === selectedPlan?.id;

  const nextPlan = data?.next;
  const isUpcoming = !!nextPlan && selectedPlan?.id === nextPlan?.plan?.id;

  // The upcoming plan surfaces its own UpcomingPlanBadge, so suppress the
  // other tags on that card.
  if (isUpcoming) return null;

  return (
    <Styled.Wrapper
      className={classnames('PlanTags', className)}
      sx={SX.root}
      direction="row"
    >
      <PlanTagline />
      <CurrentPlanTag />
      {isMostPopular && !isCurrentPlan && <MostPopularTag />}
      <NextChargeTag />
    </Styled.Wrapper>
  );
});

PlanTags.displayName = 'PlanTags';
